function PowerBIRegisters() {
  return (
    <div style={{ width: "90%", height: "90%" }}>
      <iframe
        title="Registers"
        style={{ width: "100%", height: "100%" }}
        src="https://app.powerbi.com/reportEmbed?reportId=60093530-357f-44a5-a8c6-522e5b65f9b7&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default PowerBIRegisters;
